module.exports = __webpack_public_path__ + "img/icon_address_empty_blue.a3dbc15d.svg";